import adapter from '../adapter-blog-post';
var IDs = adapter.IDs;
export default {
    type: adapter.SchemaTypes.BLOG_POST_FAQ,
    schema: {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: "{{" + IDs.FAQ + "}}",
    },
};
